import { FETCH_PACKAGES } from '../types';

const initState = {
	packages: [],
};

const discoverReducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_PACKAGES:
			return {
				...state,
				packages: action.payload,
			};
		default:
			return {
				...state,
			};
	}
};
export default discoverReducer;
